// Get Assignments
export const GET_ASSIGNMENTS_REQUEST = 'GET_ASSIGNMENTS_REQUEST';
export const GET_ASSIGNMENTS_DONE = 'GET_ASSIGNMENTS_DONE';
export const GET_ASSIGNMENTS_FAILED = 'GET_ASSIGNMENTS_FAILED';
export const GET_ASSIGNMENTS_RESET = 'GET_ASSIGNMENTS_RESET';

// Operations
export const ASSIGNMENTS_SET_PAGE = 'ASSIGNMENTS_SET_PAGE';